import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        productsGrid: {
            spacingX: {base: remCalc(8), lg: 'small.md'},
            spacingY: ['small.md'],
        },
        refinementsStack: {
            display: 'flex',
            direction: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 'small.sm',
            height: 'auto',
            borderColor: 'gray.100',
        },
        refinementsDivider: {
            my: 'small.lg',
            color: 'background.light',
        },
        selectedRefinementsContainer: {
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            paddingBottom: {
                base: remCalc(32),
                sm: remCalc(32),
                lg: 0,
            },
        },
        manualsTabPanel: {
            display: 'flex',
            flexDir: 'column',
            gap: 'small.base',
            padding: {
                base: `${remCalc(24)} ${remCalc(16)} ${remCalc(16)}`,
                lg: `${remCalc(40)} ${remCalc(16)} ${remCalc(16)}`,
            },
        },
        editorialComponentsContainer: {},
    },
}
